import { WidgetDataSource } from '../../../../../../../models';
import {
  Comparison,
  SectionFilter,
  Widget,
  WidgetGroup,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class SentimentScorePointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison,
    sectionFilter?: SectionFilter[]
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison,
      sectionFilter
    );

    const flattenedPoints = selectedPoints.flatMap((p) => p);
    for (let pointIdx = 0; pointIdx < flattenedPoints.length; pointIdx++) {
      const bucket = payload.buckets[pointIdx];
      const point = flattenedPoints[pointIdx];

      bucket.sentiment = point.y;
      bucket.sentiment_calculation = widget.payload.aggregator.replace('total_', '');

      if (widget.payload.analyticItem === 'documents') {
        delete bucket.analytic_item_value;
      }
    }

    return payload;
  }

  protected override fillWidgetQueryOptionsForPoint(widgetQueryOptions: any, point: any): void {
    super.fillWidgetQueryOptionsForPoint(widgetQueryOptions, point);

    if (typeof point.category !== 'number') {
      return;
    }

    widgetQueryOptions.widgetContextMenu.category = point.category;
    widgetQueryOptions.widgetContextMenu.series = point.series;
    widgetQueryOptions.widgetContextMenu.index = point.index;
  }
}
